/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Resident terms are non-binding. Approving a version does not send it.
 * @export
 */
export const HomeownershipTermsStatus = {
    Approved: 'approved',
    Sent: 'sent',
    Locked: 'locked',
    Declined: 'declined',
    Lapsed: 'lapsed',
    Superseded: 'superseded'
} as const;
export type HomeownershipTermsStatus = typeof HomeownershipTermsStatus[keyof typeof HomeownershipTermsStatus];


export function HomeownershipTermsStatusFromJSON(json: any): HomeownershipTermsStatus {
    return HomeownershipTermsStatusFromJSONTyped(json, false);
}

export function HomeownershipTermsStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipTermsStatus {
    return json as HomeownershipTermsStatus;
}

export function HomeownershipTermsStatusToJSON(value?: HomeownershipTermsStatus | null): any {
    return value as any;
}

